<template>
    <div class="">
<!--        <div class="top_title">-->
<!--            <div class="top_back_home" @click="backToLast">-->
<!--                <img alt="" src="../../../public/images/back.png"/>-->
<!--                <p>返回</p>-->
<!--            </div>-->
<!--            <div class="title">-->
<!--                客户管理-详情-->
<!--            </div>-->
<!--        </div>-->
        <div class="main">

            <!-- 当前客户 -->
            <div class="qiankuan_zonglan">
                <div class="title">
                    <div class="left">
                        当前客户：{{ customer.name }} {{ customer.phone == '' ? '' : '（' + customer.phone + '）' }}
                        {{ customer.remark }}
                    </div>
                </div>
                <div class="qiankuan">
                    <div class="item">
                        <h3>{{ customer.sale.name }}</h3>
                        <p>所属销售</p>
                    </div>
                    <div class="item">
                        <h3>{{ total_debt }}</h3>
                        <p>总欠款</p>
                    </div>
                    <div class="item">
                        <h3>{{ total_waive }}</h3>
                        <p>总抹零</p>
                    </div>
                </div>

            </div>

            <div class="tab_title">
                <div v-for="item in tabbarType" :key="item.id" :class="{ 'active': item.id === activeId }"
                     class="item" @click="setActive(item.id)">
                    {{ item.title }}
                </div>
            </div>

            <!-- 还款方式 -->
            <div v-if="activeId === 1" class="customer_mingxi">
                <!-- 可操作订单 -->
                <div class="sales_man">
                    <div class="title">
                        <div class="left">
                            订单还款（可操作订单未还款 + 超额还款）
                        </div>
<!--                        <div class="right">-->
<!--                            <div class="tt">-->
<!--                                欠款：-->
<!--                                <span>{{ selectTotalSurplusFee }}</span>-->
<!--                            </div>-->
<!--                            <div class="tt">-->
<!--                                还款金额：-->
<!--                                <span>{{ selectTotalMoney }}</span>-->
<!--                            </div>-->
<!--                            <div class="tt">-->
<!--                                抹零金额：-->
<!--                                <span>{{ selectTotalWaiveFee }}</span>-->
<!--                            </div>-->
<!--                            <div class="tt">-->
<!--                                还款后欠款：-->
<!--                                <span>{{ afterSurplusFee }}</span>-->
<!--                            </div>-->

<!--                        </div>-->
                    </div>
                    <div class="ordertable_control">
                        <el-table :key="`table-${activeId}-selection`" ref="firstTable" :data="noOrderDetailList"
                                  tooltip-effect="dark"
                                  cell-padding="0"
                                  @selection-change="handleSelectionChange"
                        size="mini">
                            <el-table-column type="selection" width="40">
                            </el-table-column>
                            <el-table-column label="记账时间" prop="time">
                            </el-table-column>
                            <el-table-column label="商品" prop="product_name">
                            </el-table-column>
                            <el-table-column label="数量" prop="number" width="60">
                            </el-table-column>
                            <el-table-column label="单价" prop="price" width="80">
                            </el-table-column>
                            <el-table-column label="总金额" prop="total_fee">
                            </el-table-column>
                            <el-table-column label="已还金额" prop="repayment_fee">
                            </el-table-column>
                            <el-table-column label="还款金额" prop="now_repayment_fee" width="120">
                                <template slot-scope="scope">
                                    <input v-model="scope.row.now_repayment_fee" placeholder="请输入"
                                           type="number" @input="countTheSelectedOrders(scope.$index)"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="抹零金额" prop="now_waive_fee" width="120">
                                <template slot-scope="scope">
                                    <input v-model="scope.row.now_waive_fee" placeholder="请输入"
                                           type="number" @input="countTheSelectedOrders(scope.$index)"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="剩余金额" prop="show_surplus_fee">
                            </el-table-column>
                            <el-table-column label="状态" prop="tag">
                                <template #default="scope">
                                    <el-tag v-if="scope.row.is_back == 1" disable-transitions type="danger">
                                        未还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 2" disable-transitions type="success">
                                        已还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 3" disable-transitions type="warning">
                                        部分还款
                                    </el-tag>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                    <div class="yuan_right">
                        <div class="tt">
                            欠款：
                            <span>{{ selectTotalSurplusFee }}</span>
                        </div>
                        <div class="tt">
                            还款金额：
                            <span>{{ selectTotalMoney }}</span>
                        </div>
                        <div class="tt">
                            抹零金额：
                            <span>{{ selectTotalWaiveFee }}</span>
                        </div>
                        <div class="tt">
                            还款后欠款：
                            <span>{{ afterSurplusFee }}</span>
                        </div>

                    </div>
                    <div class="sure">
                        <el-button type="primary" @click="orderRepayment">确认还款</el-button>
                    </div>

                </div>
                <!-- 金额还款 -->
                <div class="salesperson">
                    <div class="title">
                        <div class="left">
                            金额还款
                        </div>
                    </div>
                    <div class="huankuan_num">
                        <div class="huankuan_num_itt">
                            <el-input v-model="total_debt" readonly type="number">
                                <template slot="prepend">当前欠款</template>
                            </el-input>
                        </div>
                        <div class="huankuan_num_itt">
                            <el-input v-model="moneyRepaymentMoney" placeholder="请输入" type="number">
                                <template slot="prepend">还款金额</template>
                            </el-input>
                        </div>
                        <div class="sure">
                            <el-button type="primary" @click="moneyRepayment">确认还款</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 订单列表 -->
            <div v-if="activeId === 2" class="huankuan_mingxi">
                <div class="sales_man">
                    <div class="title">
                        <div class="left">
                            订单列表
                            <el-select v-model="order_list_type_value" placeholder="请选择"
                                       @change="getOrderDetailList()">
                                <el-option v-for="item in order_list_type_arr" :key="item.value"
                                           :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>

                    </div>
                    <div class="ordertable_control">
                        <el-table :key="`table-${activeId}-normal`" ref="secondTable" :data="orderDataList">
                            <el-table-column label="记账时间" prop="time">
                            </el-table-column>
                            <el-table-column label="商品" prop="product_name" width="100">
                            </el-table-column>
                            <el-table-column label="数量" prop="number">
                            </el-table-column>
                            <el-table-column label="单价" prop="price">
                            </el-table-column>
                            <el-table-column label="总金额" prop="total_fee">
                            </el-table-column>
                            <el-table-column label="还款时间" prop="back_time">
                                <template #default="scope">
                                    <div v-if="scope.row.is_back == 1" style="color: rgb(245, 108, 108);">未还款</div>
                                    <div v-else>{{ scope.row.back_time }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="还款信息" prop="repayment_fee">
                                <template #default="scope">
                                    <div style="color: rgb(103, 194, 58);">已还：{{ scope.row.repayment_fee }}</div>
                                    <div style="color: rgb(230, 162, 60);">抹零：{{ scope.row.waive_fee }}</div>
                                    <div style="color: rgb(245, 108, 108);">剩余：{{ scope.row.surplus_fee }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" prop="tag">
                                <template #default="scope">
                                    <el-tag v-if="scope.row.is_back == 1" disable-transitions size="mini" type="danger">
                                        未还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 2" disable-transitions size="mini"
                                            type="success">
                                        已还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 3" disable-transitions size="mini"
                                            type="warning">
                                        部分还款
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column label="操作" prop="control" width="100">
                                <template #default="scope">
                                    <div>
                                        <el-link type="primary" @click="showBackDetail(scope.row.id)">还款详情</el-link>
                                    </div>
                                    <div>
                                        <el-link type="danger" @click="delOrderDetail(scope.row)">删除</el-link>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

            </div>

            <!-- 还款统计 -->
            <div v-if="activeId === 1" class="sales_man">
                <div class="title">
                    <div class="left">
                        还款统计
                    </div>
                    <div class="right">
                        <div class="ll">
                            <div :class="repaymentDateType == 0 ? 'itte active' : 'itte'"
                                 @click="selectRepaymentDateType(0)">
                                今日
                            </div>
                            <div :class="repaymentDateType == 1 ? 'itte active' : 'itte'"
                                 @click="selectRepaymentDateType(1)">
                                本月
                            </div>
                            <div :class="repaymentDateType == 2 ? 'itte active' : 'itte'"
                                 @click="selectRepaymentDateType(2)">
                                自定义
                            </div>
                        </div>
                        <div class="cc">
                            <el-date-picker v-model="repaymentDaterange" end-placeholder="结束日期" format="yyyy-MM-dd"
                                            range-separator="~" start-placeholder="开始日期"
                                            type="daterange" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                        <div class="shuaxin" @click="getRepaymentList(1)">
                            <img alt="" src="../../../public/images/shauxin.png" srcset=""/>
                        </div>
                    </div>
                </div>
                <div class="ml_money">
                    <div class="zong">
                        总还款<p>{{ total_repayment }}</p>
                    </div>
                    <div class="tong">
                        统计范围还款<p>{{ range_repayment }}</p>
                    </div>
                </div>
                <div class="table">
                    <el-table :data="repaymentList" max-height="280" style="width: 100%">
                        <el-table-column label="还款时间" prop="back_time">
                        </el-table-column>
                        <el-table-column label="还款金额" prop="money">
                        </el-table-column>
                        <el-table-column label="还款方式" prop="back_type">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.back_type == 1 ? 'info' : 'success'" disable-transitions
                                        size="small">{{ scope.row.back_type == 1 ? '订单还款' : '金额还款' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <el-dialog
            title="订单还款详情"
            :visible.sync="backDetailDialogVisible"
            :close-on-click-modal="false"
            width="70%"
            center>
            <div>
                <el-descriptions class="margin-top" title="订单信息" :column="3" border>
                    <template slot="extra">
<!--                        <el-button type="primary" size="small">操作</el-button>-->
                    </template>
                    <el-descriptions-item>
                        <template slot="label">
                            客户名称
                        </template>
                        {{ backDetail.customer_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            销售员
                        </template>
                        {{ backDetail.sale_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            日期
                        </template>
                        {{ backDetail.time }}
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            商品名称
                        </template>
                        {{ backDetail.product_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            数量
                        </template>
                        {{ backDetail.number }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            单价
                        </template>
                        {{ backDetail.price }}
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            总金额
                        </template>
                        {{ backDetail.total_fee }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            还款金额
                        </template>
                        {{ backDetail.repayment_fee }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            剩余金额
                        </template>
                        {{ backDetail.surplus_fee }}
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            抹零金额
                        </template>
                        {{ backDetail.waive_fee }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            羊下水
                        </template>
                        <el-tag v-if="backDetail.is_offal == 1" type="success" size="small">否</el-tag>
                        <el-tag v-if="backDetail.is_offal == 2" type="danger" size="small">是</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            还款状态
                        </template>
                        <el-tag v-if="backDetail.is_back == 1" type="danger" size="small">未还</el-tag>
                        <el-tag v-if="backDetail.is_back == 2" type="success" size="small">已还</el-tag>
                        <el-tag v-if="backDetail.is_back == 3" type="warning" size="small">部分</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            还款方式
                        </template>
                        <div v-if="backDetail.is_back != 1">
                            <el-tag v-if="backDetail.back_type == 1" size="small">订单还款</el-tag>
                            <el-tag v-if="backDetail.back_type == 2" type="success" size="small">金额还款</el-tag>
                            <el-tag v-if="backDetail.back_type == 3" type="warning" size="small">订单+金额</el-tag>
                        </div>
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-office-building"></i>
                            批次
                        </template>
                        {{ backDetail.batch_name }}
                    </el-descriptions-item>
                </el-descriptions>

                <el-row style="margin-bottom: 30px;">
                    <el-row class="back_title" style="font-size: 16px;font-weight: 700;margin-top: 30px;">还款记录</el-row>
                    <el-table
                        :data="backDetailList"
                        style="width: 100%">
                        <el-table-column
                            prop="back_time"
                            label="还款时间">
                        </el-table-column>
                        <el-table-column
                            label="还款方式">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.back_type == 1">订单</el-tag>
                                <el-tag v-if="scope.row.back_type == 2" type="success">金额</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="money"
                            label="还款金额">
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status == 1" type="success" effect="dark" size="mini">正常</el-tag>
                                <el-tag v-if="scope.row.status == 2" type="danger" effect="dark" size="mini">已撤销</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status == 1" type="danger" size="mini" @click="revoke(scope.row.id)">撤销</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>

<!--                <el-descriptions title="用户信息">-->
<!--                    <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>-->
<!--                    <el-descriptions-item label="手机号">18100000000</el-descriptions-item>-->
<!--                    <el-descriptions-item label="居住地">苏州市</el-descriptions-item>-->
<!--                    <el-descriptions-item label="备注">-->
<!--                        <el-tag size="small">学校</el-tag>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="联系地址">江苏省苏州市吴中区吴中大道 1188 号</el-descriptions-item>-->
<!--                </el-descriptions>-->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="backDetailDialogVisible = false">取 消</el-button>
<!--                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>-->
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: 0,
            activeId: 1, // 当前激活的元素 ID
            tabbarType: [
                {
                    id: 1,
                    title: '还款操作'
                },
                {
                    id: 2,
                    title: '订单列表'
                }
            ],
            customer: {
                name: '',
                phone: '',
                remark: '',
                sale: {name: ''},
            },
            total_debt: '',// 总欠款
            total_waive: '',// 总抹零
            noOrderDetailList: [], // 未还款订单
            multipleSelection: [], // 选择
            selectTotalSurplusFee: 0,
            selectTotalMoney: 0,
            selectTotalWaiveFee: 0,
            afterSurplusFee: 0,
            //金额还款
            moneyRepaymentMoney: '',
            // 还款记录
            repaymentDateType: 0,
            repaymentDaterange: '',
            total_repayment: '',
            repaymentList: [],
            range_repayment: '',

            // 订单列表状态
            order_list_type_arr: [
                {
                    value: 0,
                    label: '全部订单'
                },
                {
                    value: 1,
                    label: '已还款'
                },
                {
                    value: 2,
                    label: '未还款'
                },
                {
                    value: 3,
                    label: '部分还款'
                }
            ],
            order_list_type_value: 0,
            orderDataList: [],

            backDetailDialogVisible: false,
            backDetail: {},
            backDetailList: [],
        }
    },
    mounted() {
        this.id = this.getUrlParam('id');
        this.getCustomerDetail();
    },
    methods: {
        getUrlParam(name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        //返回上一页
        backToLast() {
            this.$router.push({
                path: '/customer',
            })
        },
        //点击切换
        setActive(id) {
            if (this.activeId != id) {
                this.activeId = id;
                // 加载数据
                this.getCustomerDetail();
            }
        },

        getCustomerDetail() {
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/customer/getCustomerDetail', {id: this.id}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.customer = res.data.data.customer;
                    this.total_debt = res.data.data.total_debt;
                    this.total_waive = res.data.data.total_waive;
                    if (this.activeId == 1) {
                        this.getCustomerOrderDetailListByNoBack(0);
                        this.getRepaymentList(0);
                    } else {
                        // 订单列表
                        this.getOrderDetailList();
                    }

                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 加载订单未还款列表
        getCustomerOrderDetailListByNoBack(isShow = 1) {
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.post('/order/getCustomerOrderDetailListByNoBack', {
                id: this.id,
            }).then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    for (var i=0; i<res.data.data.length; i++) {
                        res.data.data[i].show_surplus_fee = res.data.data[i].surplus_fee;
                    }
                    this.noOrderDetailList = res.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 订单选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.countTheSelectedOrders(-1);
        },
        // 统计选中订单
        countTheSelectedOrders(index = -1) {
            // 处理当前剩余
            if(index >= 0){
                var surplus_fee = this.noOrderDetailList[index].surplus_fee;
                var now_repayment_fee = 0;
                var now_waive_fee = 0;
                if (this.noOrderDetailList[index].hasOwnProperty('now_repayment_fee')) {
                    now_repayment_fee = (+this.noOrderDetailList[index].now_repayment_fee);
                }
                if (this.noOrderDetailList[index].hasOwnProperty('now_waive_fee')) {
                    now_waive_fee += (+this.noOrderDetailList[index].now_waive_fee);
                }
                var show_surplus_fee = surplus_fee - now_repayment_fee - now_waive_fee;
                this.noOrderDetailList[index].show_surplus_fee = show_surplus_fee;
            }

            // 统计选中订单
            var selectTotalSurplusFee = 0;
            var selectTotalMoney = 0;
            var selectTotalWaiveFee = 0;
            var afterSurplusFee = 0;
            for (var i = 0; i < this.multipleSelection.length; i++) {
                selectTotalSurplusFee += (+this.multipleSelection[i].surplus_fee);
                if (this.multipleSelection[i].hasOwnProperty('now_repayment_fee')) {
                    selectTotalMoney += (+this.multipleSelection[i].now_repayment_fee);
                }
                if (this.multipleSelection[i].hasOwnProperty('now_waive_fee')) {
                    selectTotalWaiveFee += (+this.multipleSelection[i].now_waive_fee);
                }
            }
            afterSurplusFee = selectTotalSurplusFee - selectTotalMoney - selectTotalWaiveFee;
            this.selectTotalSurplusFee = selectTotalSurplusFee;
            this.selectTotalMoney = selectTotalMoney;
            this.selectTotalWaiveFee = selectTotalWaiveFee;
            this.afterSurplusFee = afterSurplusFee;
        },

        // 订单还款
        orderRepayment() {
            if (this.multipleSelection.length <= 0) {
                this.$message({
                    type: 'error',
                    message: '请选择还款订单'
                })
                return false;
            }
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            this.$http.post('/order/orderRepayment', {
                order: this.multipleSelection,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getCustomerDetail();
                        }
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 金额还款
        moneyRepayment() {
            var moneyRepaymentMoney = +this.moneyRepaymentMoney;
            if (moneyRepaymentMoney <= 0) {
                this.$message({
                    type: 'error',
                    message: '请输入还款金额'
                })
                return false;
            }
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            this.$http.post('/order/moneyRepayment', {
                money: moneyRepaymentMoney,
                customer_id: this.id,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.moneyRepaymentMoney = '';
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getCustomerDetail();
                        }
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 切换还款记录筛选时间类型
        selectRepaymentDateType(type) {
            if (type != this.repaymentDateType) {
                this.repaymentDateType = type;
                if (type != 2) {
                    this.getRepaymentList(1);
                }
            }
        },
        // 获取还款记录
        getRepaymentList(isShow = 1) {
            if (this.id <= 0) {
                this.$message({
                    type: 'error',
                    message: '参数有误',
                })
                return false;
            }
            if (this.repaymentDateType == 2) {
                if (!Array.isArray(this.repaymentDaterange)) {
                    this.$message({
                        type: 'error',
                        message: '请选择时间范围',
                    })
                    return false;
                }
            }
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.post('/repayment/getRepaymentList', {
                customer_id: this.id,
                repaymentDateType: this.repaymentDateType,
                repaymentDaterange: this.repaymentDaterange,
            }).then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    this.repaymentList = res.data.data.repaymentList;
                    this.total_repayment = res.data.data.total_repayment;
                    this.range_repayment = res.data.data.range_repayment;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 获取订单列表
        getOrderDetailList() {
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/getOrderDetailList', {
                customer_id: this.id,
                order_type: this.order_list_type_value,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.orderDataList = res.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 删除
        delOrderDetail(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/order/delOrderDetail', {
                    id: row.id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.getCustomerDetail();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 展示还款详情
        showBackDetail(id){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/getBackDetail', {
                id: id,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.backDetail = res.data.data.detail;
                    this.backDetailList = res.data.data.repaymentList;
                    this.backDetailDialogVisible = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 撤销还款
        revoke(id){
            this.$confirm('确定撤销此还款吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/order/revokeRepayment', {
                    id: id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.showBackDetail(this.backDetail.id);
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;

    .qiankuan_zonglan {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #3D3D3D;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 18px;
                    color: #3D3D3D;
                }
            }
        }

        .qiankuan {
            display: flex;
            align-items: center;
            background: #F5F6FC;
            margin-bottom: 12px;
            padding: 8px 0;

            .item {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                h3 {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 32px;
                    color: #333;
                    line-height: 48px;
                }

                p {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #4A5676;
                }
            }

            .item:first-child {
                h3 {
                    color: #3F72FF;
                }
            }

            .item:nth-child(2) {
                h3 {
                    color: #FF7700;
                }
            }

            .item:last-child {
                h3 {
                    color: #389F0D;
                }
            }
        }
    }

    .tab_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0px;

        .item {
            flex: 0 0 48%;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #3F72FF;
            line-height: 50px;
            cursor: pointer;
            border-radius: 50px;
            border: 1px solid #3F72FF;
            text-align: center;
            box-sizing: border-box;
        }

        .item.active {
            color: #fff;
            position: relative;
            background: #3F72FF;
            border: 1px solid #3F72FF;
        }

        .item.active::after {
            //content: '';
            //display: block;
            //position: absolute;
            //left: 50%;
            //bottom: -10px;
            //transform: translate(-50%, 0);
            //width: 25px;
            //height: 5px;
            //background: #3F72FF;
        }
    }


    .salesperson {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3D3D3D;

                    span {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 18px;
                        color: #3D3D3D;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .search {
                    margin-right: 12px;
                }

                .paixu {
                    margin-right: 4px;
                }

                .add_customer {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                    margin-left: 12px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .salesperson_money {
            width: 100%;
            display: flex;
            align-items: center;

            .item {
                flex: 0 0 22%;
                margin-right: 3%;
                background: #fff;
                border-radius: 8px 8px 8px 8px;
                padding: 16px;
                box-sizing: border-box;

                .tt {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333;
                    line-height: 22px;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .bb {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #3F72FF;
                    line-height: 32px;
                }
            }

            .item:first-child {
                background: #F5F6FC;

                .bb {
                    color: #3F72FF;
                }
            }

            .item:nth-child(2) {
                background: #FFFBEF;

                .bb {
                    color: #FFCC00;
                }
            }

            .item:nth-child(3) {
                background: #FCF5F5;

                .bb {
                    color: #FF4D4F;
                }
            }

            .item:last-child {
                margin-right: 0;
                background: #F5FCF5;

                .bb {
                    color: #389F0D;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }

        .huankuan_num {
            .huankuan_num_itt {
                margin-bottom: 20px;
            }
        }
    }

    .huankuan_order_list {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3D3D3D;

                    span {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 18px;
                        color: #3D3D3D;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .search {
                    margin-right: 12px;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }

        .pagination {
            margin-top: 16px;

            .el-pagination {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .sure {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sales_man {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }
            .right {
                display: flex;
                align-items: center;

                .tt {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    margin-right: 10px;

                    span {
                        font-weight: bold;
                    }
                }

                .tt:first-child {
                    span {
                        color: #409eff;
                    }
                }

                .tt:nth-child(2) {
                    span {
                        color: #e6a23c;
                    }
                }

                .tt:nth-child(3) {
                    span {
                        color: #67c23a;
                    }
                }

                .sure {
                    background: #3F72FF;
                    color: #fff;
                    border-radius: 3px 3px 3px 3px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 30px;
                    padding: 0 12px;
                    margin-right: 8px;
                    cursor: pointer;
                }

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .search {
                    margin-right: 12px;
                }

                .paixu {
                    margin-right: 4px;
                }

                .add_customer {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                    margin-left: 12px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }
            }


        }

        .ordertable_control {
            margin-bottom: 20px;

            input {
                height: 30px;
                line-height: 30px;
                border: 1px solid #eee;
                padding-left: 10px;
                box-sizing: border-box;
                width: 100%;
            }
        }

        .yuan_right {
            display: flex;
            align-items: center;

            .tt {
                display: flex;
                align-items: center;
                font-size: 16px;
                margin-right: 10px;

                span {
                    font-weight: bold;
                }
            }

            .tt:first-child {
                span {
                    color: #409eff;
                }
            }

            .tt:nth-child(2) {
                span {
                    color: #e6a23c;
                }
            }

            .tt:nth-child(3) {
                span {
                    color: #67c23a;
                }
            }

            .sure {
                background: #3F72FF;
                color: #fff;
                border-radius: 3px 3px 3px 3px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                line-height: 30px;
                padding: 0 12px;
                margin-right: 8px;
                cursor: pointer;
            }

            .ll {
                display: flex;
                align-items: center;

                .itte {
                    background: #F5F6FC;
                    border-radius: 3px 3px 3px 3px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #4A5676;
                    line-height: 30px;
                    padding: 0 12px;
                    margin-right: 8px;
                    cursor: pointer;
                }

                .itte.active {
                    background: #3F72FF;
                    color: #fff;
                }
            }

            .shuaxin {
                margin-left: 8px;
                cursor: pointer;

                img {
                    display: block;
                    width: 20px;
                    height: 20px;
                }
            }

            .search {
                margin-right: 12px;
            }

            .paixu {
                margin-right: 4px;
            }

            .add_customer {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #3F72FF;
                margin-left: 12px;
                cursor: pointer;

                img {
                    display: block;
                    width: 20px;
                    height: 20px;
                }
            }
        }


        .pagination {
            .el-pagination {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }

        .ml_money {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;

            .zong {
                flex: 0 0 48%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F5F6FC;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 52px;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #3F72FF;
                    margin-left: 12px;
                }
            }

            .tong {
                flex: 0 0 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F5FCF5;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 52px;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #389F0D;
                    margin-left: 12px;
                }
            }
        }
    }


    .dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;

        .dialog-content {
            background: white;
            border-radius: 8px;
            width: 80%;
            max-width: 90%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            padding: 24px;

            .dialog-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #4A5676;
                margin-bottom: 26px;

                img {
                    display: block;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .dialog-body {
                .item {
                    margin-bottom: 20px;

                    .title {
                        display: flex;
                        align-items: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #36363A;
                        margin-bottom: 12px;

                        span {
                            color: #CB2D18;
                        }
                    }

                    .con {
                        .el-select {
                            width: 100%;
                        }
                    }
                }

                .control {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 20px;

                    .itt {
                        width: 96px;
                        height: 40px;
                        border-radius: 4px 4px 4px 4px;
                        box-sizing: border-box;
                        line-height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        text-align: center;
                        margin-left: 16px;
                        cursor: pointer;
                    }

                    .quxiao {
                        border: 1px solid #E5E5E7;
                        color: #36363A;

                    }

                    .sure {
                        background: #3F72FF;
                        border: 1px solid #3F72FF;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }

}

/* 清除表体td、表头th 内边距 */
::v-deep .el-table__body td.el-table__cell,
::v-deep .el-table__header th.el-table__cell {
    padding: 0 !important;
}
/* 清除单元格内部文字容器的padding（关键，否则还有留白） */
::v-deep .el-table .cell {
    padding: 0 !important;
}
</style>
